export default "__VITE_ASSET__EC9dwCbP__"